module.exports = __webpack_public_path__ + "img/mvl_landing.89b8c841.png";